export const DATA_REFERENCE = "DATA_REFERENCE";
export const APP_ID_KEY = "app_id";
export const CHANNEL_KEY = "channel";
export const TERMINAL_KEY = "terminal";
export const SECTOR_KEY = "sector";
export const MOVEMENT_KEY = "movement";
export const POS_TILL_KEY = "posTillNo";
export const BOOKING_SOURCE = "bookingSource";
export const DELIVERY_ENABLED = "deliveryEnabled";
